import { render, staticRenderFns } from "./ConsultarTicket.vue?vue&type=template&id=43a45435&scoped=true&"
import script from "./ConsultarTicket.vue?vue&type=script&lang=js&"
export * from "./ConsultarTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a45435",
  null
  
)

export default component.exports